import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const PositionsCreate = () => {
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [location, setLocation] = useState("");
	const [type, setType] = useState("");
	const [description, setDescription] = useState("");
	const [responsibilities, setResponsibilities] = useState("");
	const [loading, setLoading] = useState(false);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة وظيفة جديدة",
				breadcrumb: "التوظيف",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/postions`,
				{
					title,
					location,
					type,
					description,
					responsibilities,
					page_title: pageTitle,
					page_description: pageDescrition,
					page_keywords: pageKeyWords,
					page_url_title: pageUrl,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/positions/index");
				toast.success("تم اضافة الوظيفة بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="col-md-4">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-item">
											<label htmlFor="location">الموقع</label>
											<input
												type="text"
												id="location"
												required
												onChange={e => setLocation(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-item">
											<label htmlFor="type">النوع</label>
											<select id="type" onChange={e => setType(e.target.value)}>
												<option value="">اختر النوع</option>
												<option value="full_time">Full time</option>
												<option value="part_time">Part time</option>
												<option value="remotely">Remotely</option>
											</select>
										</div>
									</div>
								</div>
								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="responsibilities">المسؤوليات</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setResponsibilities(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
									></textarea>
								</div>
								<div className="form-item">
									<button className="bt bt-success">ارسال</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default PositionsCreate;
